import React from 'react';
import { getTestimonials } from '../mockData';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Testimonials = () => {
  const { language } = useLanguage();
  const testimonials = getTestimonials(language);

  return (
    <section id="referenzen" className="py-20 bg-gradient-to-br from-sky-50 to-amber-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {language === 'en' ? 'What our ' : 'Was unsere '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-amber-500">
              {language === 'en' ? 'Customers' : 'Kunden'}
            </span>
            {language === 'en' ? ' say' : ' sagen'}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {language === 'en' 
              ? 'Over 500 satisfied customers trust Gravante'
              : 'Über 500 zufriedene Kunden vertrauen auf Gravante'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 bg-white hover:shadow-xl transition-all duration-300 hover:-translate-y-1 hover-lift animate-fadeInUp" style={{ animationDelay: `${index * 0.15}s` }}>
              <CardContent className="p-8">
                <div className="flex items-center mb-4">
                  <Quote className="w-8 h-8 text-sky-600 opacity-50" />
                </div>
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-amber-400 fill-current" />
                  ))}
                </div>
                <p className="text-gray-700 mb-6 leading-relaxed italic">
                  &ldquo;{testimonial.text}&rdquo;
                </p>
                <div className="border-t border-gray-200 pt-4">
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
